var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.cliniqueIdLoyaltyV1 = {
    $container: $(),
    attach: function (context) {
      var self = this;

      self.init(context);
    },
    getDom: function (context) {
      var self = this;

      self.$container = $('.js-product-full-loyalty-price', context);
      self.originalPrice = $('.js-product-full__price', context);
    },
    getOfferData: function (context) {
      var self = this;

      site.onLoadRpc.requests = site.onLoadRpc.requests || [];
      site.onLoadRpc.requests.push({
        'method': 'offers.getOffersRpcData',
        'params': [{ 'offer_type': 'loyalty_sitewide_discount' }],
        'onSuccess': function (response) {
          if (!response || !response.result || !response.result.value || !response.result.value.offers) {
            return;
          }
          var resultValue = response.result.value;

          // Extract the offer status into a loyalty level array
          page_data.offers_data = page_data.offers_data || {};
          page_data.offers_data.loyalty_Offers = page_data.offers_data.loyalty_Offers || [];
          Object.keys(resultValue.offers).forEach(function (offerCode) {
            var loyaltyOffer = {};

            loyaltyOffer.offer_code = offerCode;
            var offer = resultValue.offers[offerCode];

            if (Object.prototype.hasOwnProperty.call(offer, 'benefits')) {
              var benefits = offer.benefits[0];

              if (!!benefits) {
                loyaltyOffer.discount = benefits.value ? parseInt(benefits.value) : 0;
                loyaltyOffer.skus = benefits.includes ? benefits.includes : [];
                page_data.offers_data.loyalty_Offers.push(loyaltyOffer);
              }
            }
          });

          // Sort lowest to highest
          page_data.offers_data.loyalty_Offers.sort(function (a, b) {
            return a.discount === b.discount ? 0 : a.discount > b.discount ? 1 : -1;
          });

          $(document).on('prodcat.status', function (e, data) {
            var prodcatData;

            if (data.result && data.result.value && data.result.value.products) {
              prodcatData = data.result.value.products;
            }
            var productId = $('.js-product-full', context).data('productid');

            if (prodcatData && productId) {
              prodcatData.forEach(function (value) {
                if (value.PRODUCT_ID === productId) {
                  value.skus.forEach(function (data) {
                    if (data.isOrderable === 1 && data.isDiscountable === 1) {
                      self.setLoyaltyData(data, context);
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    setLoyaltyData: function (data) {
      this.attached = true;
      var self = this;
      var currency = self.$container.data('currencySymbol') || '';
      var loyaltyPrice = self.$container.find('.js-loyalty-price');

      if (loyaltyPrice.length > 0 && self.originalPrice.length > 0) {
        var loyaltyOffers = page_data.offers_data.loyalty_Offers;

        loyaltyOffers.forEach(function (el) {
          if (el.skus) {
            var originalPrice = self.originalPrice.text();

            originalPrice = originalPrice.substring(0, originalPrice.lastIndexOf(' ')).replace(/ /g, '');
            var priceBase = parseFloat(originalPrice);

            if (el.skus.indexOf(data.SKU_BASE_ID) >= 0 && priceBase) {
              var discountedPrice = priceBase - priceBase * el.discount / 100;

              if (Drupal.settings.globals_variables && !Drupal.settings.globals_variables.disable_float_price) {
                discountedPrice = Number.parseFloat(discountedPrice).toFixed(2);
              } else {
                discountedPrice = Math.round(discountedPrice);
              }
              loyaltyPrice.text(discountedPrice + ' ' + currency);
              self.$container.addClass('active');
            }
          }
        });
      }
    },
    init: function (context) {
      var self = this;

      self.getDom(context);
      if (self.$container.length > 0) {
        self.getOfferData(context);
      }
    }
  };
})(jQuery);
